var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-tag",class:_setup.baseTagClasses},[_c('span',{staticClass:"base-tag__span"},[_vm._t("default"),_vm._v(" "+_vm._s(_setup.renewalStatusText)+" "+_vm._s(_setup.userRoleText)+" ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }